import { ISuperPacmanFetchInstallmentRequest, ISuperPacmanInstallment } from "@/types/ISuperPacman";
import { FetchSuperPacmanInstallment } from "./DataService";
import { IAuthError } from "@/types/auth";
import authHelper from "@/helpers/authHelper";
import { decryptSuperPacmanFinanceProductPii } from "@/helpers/piiEncryption.helper";

export class APISuperPacmanInstallment implements FetchSuperPacmanInstallment {
  async fetchData(params: ISuperPacmanFetchInstallmentRequest): Promise<ISuperPacmanInstallment> {
    const SHARED_PASSWORD = process.env.VUE_APP_MIDDLEWARE_SHARED_SECRET || "";
    try {
      params["sharedSecret"] = SHARED_PASSWORD;
      const response = await authHelper.fetchSuperPacmanInstallments(params);
      // Backend encrypts customerName/Phone/Email/NationalIdNumber; decrypt
      // here so every downstream consumer reads plaintext from the store.
      await decryptSuperPacmanFinanceProductPii(response);
      // Uncomment line below to test for vpop-180
      response["cumulativeBalance"]["enabled"] = response["cumulativeBalance"]["cumulativeBalanceEnabled"] ?? false;
      return response;
    } catch (error) {
      if (error instanceof IAuthError) {
        console.error(`Authentication failed: ${error.message}`);
      }
      throw error;
    }
  }
}
